<template>
  <div class="page">
    <div class="content">
      <div class="head">
        <!-- <h2>根据录入的信息，小助手为您推荐以下达人</h2> -->
        <h2 v-show="!listShow">根据录入的信息，小助手为您推荐以下达人</h2>
        <h2 v-show="listShow && tableData.length !== 0">根据录入的信息，小助手为您推荐以下达人</h2>
        <h2 v-show="listShow && tableData.length === 0">正在为您推荐符合条件的达人...</h2>
        <p>录入的信息更全面，匹配的达人更加符合您的推广需求</p>
      </div>
      <div v-show="!listShow">
        <div class="condition">
          <div class="option_box">
            <h3>您要推广的内容</h3>
            <div class="input_boxs">
              <div class="input_box">
                <span class="box_title">行业</span>
                <el-cascader class="el_sel" v-model="industry" :options="industrys" popper-class="select">
                </el-cascader>
              </div>
              <div class="input_box">
                <span class="box_title">品牌 / 产品</span>
                <el-input class="el_input" v-model="productName" placeholder="请输入，例如：宝马/A6"></el-input>
              </div>
            </div>
          </div>
          <div class="option_box">
            <h3>您的推广目标</h3>
            <div class="check_boxs">
              <div class="check_box" v-for="(item, index) of target_options" :key="index"
                :class="item.checked ? 'active': ''" @click="setTarget(item)">
                <div class="check_img">
                  <img :src="item.checked ? item.srcActive : item.imgSrc" alt="">
                </div>
                <div class="check_info">
                  <h4>{{item.name}}</h4>
                  <p>{{item.describe}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="option_box">
            <h3>达人价格范围</h3>
            <div class="extension">
              <span class="box_title">预算</span>
              <div class="sel_price">
                <div class="price_out" v-for="item of extension_options" :key="item.id">
                  <div class="option_price" :class="item.checked ? 'active' : ''" @click="setPrice(item)">
                    <h4 v-show="!item.toInput">{{item.name}}</h4>
                    <div class="price_input" v-if="item.toInput">
                      <input type="text" v-model="price" @blur="setPriceName(item)" ref="toInput">
                      万元
                    </div>
                    <p :class="textActive ? 'active' : ''">{{item.describe}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="option_box">
            <h3>设置达人粉丝画像</h3>
            <div class="portrait">
              <div class="portrait_box">
                <span class="box_title">粉丝性别</span>
                <div class="Gender_box">
                  <div class="Gender" v-for="(item,index) of Genders" :key="index" :class="item.checked ? 'active' : ''"
                    @click="setGender(item)">
                    {{item.name}}</div>
                </div>
              </div>
              <div class="portrait_box">
                <span class="box_title">粉丝年龄</span>
                <div class="Gender_box">
                  <div class="age" v-for="(item,index) of ages" :key="index" :class="item.checked ? 'active' : ''"
                    @click="setAges(item)">
                    {{item.name}}</div>
                </div>
              </div>
              <div class="portrait_box">
                <span class="box_title">粉丝地域</span>
                <div class="Gender_box">
                  <div class="Gender" :class="(!setArea) ? 'active' : ''" @click="setArea = false">不限</div>
                  <div class="Gender" :class="setArea ? 'active' : ''" @click="setArea = true">自定义</div>
                </div>
                <div class="select_area" v-show="setArea">
                  <div class="box">
                    <div class="title">
                      <h5>选项</h5>
                    </div>
                    <div class="area_option">
                      <div class="area" :class="allChecked ? 'active' : ''" @click="setAreaBtn('all')">
                        <i></i> 全部
                      </div>
                      <div class="area" v-for="(item,index) of areas" :key="index" @click="setAreaBtn(item)"
                        :class="item.checked ? 'active' : ''">
                        <i></i> {{item.name}}
                      </div>
                    </div>
                  </div>
                  <div class="box">
                    <div class="title">
                      <h5>已选</h5>
                      <div @click="setSelectedAreas('all')">清空</div>
                    </div>
                    <div class="Selected">
                      <div class="Selected_item" v-for="(item, index) of selectedAreas" :key="index"
                        @click="setSelectedAreas(item)">{{item}}<i></i></div>
                      <div class="nothing" v-show="selectedAreas.length === 0">
                        <i></i>
                        <p>暂未选择</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="option_box">
            <h3>您的视频偏好风格</h3>
            <div class="like_style">
              <div :class="allStyle ? 'active': ''" @click="setStyle('all')">不限</div>
              <div class="style_checked" :class="item.checked ? 'active' : ''" v-for="(item,index) of styles"
                :key="index" @click="setStyle(item)">{{item.name}}</div>
            </div>
          </div>
        </div>
        <div class="btn_box">
          <div class="btn" @click="matching">匹配达人</div>
        </div>
      </div>
      <div v-show="listShow" class="list">
        <div class="hasData" v-show="tableData.length !== 0">
          <div class="matchingInfo">
            <div class="title">匹配信息</div>
            <el-tooltip effect="dark" placement="bottom">
              <div slot="content" style="width: 400px">{{describe}}</div>
              <div class="info">{{describe}}</div>
            </el-tooltip>
            <div class="btn" @click="backSet">修改条件</div>
          </div>
          <div class="rec">
            <h5>为您推荐的达人</h5>
            <div class="btn" @click="changeData()"><i class="el-icon-sort"></i>换一换</div>
          </div>
          <div class="keywords">
            <p>试试这些关键词，匹配更准确</p>
            <div class="keyword" :class="item.checked ? 'active' : ''" v-for="(item,index) of keyWords" :key="index"
              @click="setKeyword(item)">{{item.name}}</div>
          </div>
          <div class="datas">
            <div v-show="!showNoData" class="item" v-for="(item,index) of tableData" :key="index"
              @dblclick="tableBtnClick(item)">

              <img :src="item.avatar_uri" alt="">
              <div class="info">
                <h2>{{item.nick_name}}</h2>
                <div class="cate">{{item.tags_content ? item.tags_content[0] : ''}}</div>
                <div class="tags">
                  <div class="tag" v-for="(tag, index1) of item.recommend_types" :key="index1">{{tag}}
                  </div>
                </div>
              </div>
              <div class="num">
                <div>
                  {{item.follower > 10000 ? ((item.follower/10000).toFixed(1) + 'w') : item.follower}}
                </div>
                <p>粉丝数</p>
              </div>
              <div class="num">
                <div>
                  {{item.expected_play_num > 10000 ? ((item.expected_play_num/10000).toFixed(1) + 'w') : item.expected_play_num}}
                </div>
                <p>预期播放量</p>
              </div>
              <div class="line"></div>
              <div class="price">
                <span>￥</span>
                <div class="price_text">{{item.min_price.toLocaleString()}}</div>
                <el-popover placement="bottom" width="300" trigger="hover" @show="getPriceDetail(item)">
                  <div class="in_preview">
                    <h3>价格预览</h3>
                    <div class="price_item" v-for="(price_item, index2) of item.prices" :key="index2">
                      <div class="title">{{price_item.desc}}</div>
                      <div class="corr_price">
                        <span>￥</span>
                        <div class="price_t">{{price_item.price.toLocaleString()}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="preview" slot="reference"><i></i></div>
                </el-popover>

                <div></div>
              </div>
              <div class="btn" @click="tableBtnClick(item)">
                详情
              </div>
            </div>
            <div v-show="showNoData" class="datas_noData">
              <img src="../../assets/help/nodata.gif" alt="">
              <p>匹配中，请稍等...</p>
            </div>
          </div>
        </div>
        <div class="noData" v-show="tableData.length === 0">
          <img src="../../assets/help/nodata.gif" alt="">
          <p>匹配中，请稍等...</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import brand from '@/assets/help/brand.png'
  import brandActive from '@/assets/help/brand_active.png'
  import down from '@/assets/help/download.png'
  import downActive from '@/assets/help/download_active.png'
  // import movie from '@/assets/help/movie.png'
  // import movieActive from '@/assets/help/movie_active.png'
  // import online from '@/assets/help/online_retailers.png'
  // import onlineActive from '@/assets/help/online_retailers_active.png'
  // import store from '@/assets/help/store.png'
  // import storeActive from '@/assets/help/store_active.png'
  // import track from '@/assets/help/track.png'
  // import trackActive from '@/assets/help/track_active.png'
  export default {
    data() {
      return {
        industry: '',
        productName: '',
        price: '',
        textActive: false,
        setArea: false,
        industrys: [],
        listShow: false,
        target_options: [{
            name: '品牌传播',
            describe: '让达人为您的品牌发声，提升品牌美誉度',
            imgSrc: brand,
            srcActive: brandActive,
            checked: true,
            id: 1
          }, {
            name: '应用下载',
            describe: '让达人为您推广APP，提升下载量',
            imgSrc: down,
            srcActive: downActive,
            checked: false,
            id: 2
          },
          //  {
          //   name: '电商卖货',
          //   describe: '让达人为您的商品进行种草推荐，提升销量',
          //   imgSrc: online,
          //   srcActive: onlineActive,
          //   checked: false,
          //   id: 3
          // }, {
          //   name: '影视宣传',
          //   describe: '让达人为您推广影视作品',
          //   imgSrc: movie,
          //   srcActive: movieActive,
          //   checked: false,
          //   id: 4
          // }, {
          //   name: '门店推广',
          //   describe: '邀请达人探店，为您推广线下门店',
          //   imgSrc: store,
          //   srcActive: storeActive,
          //   checked: false,
          //   id: 5
          // }, {
          //   name: '线索收集',
          //   describe: '让达人为您获取销售线索',
          //   imgSrc: track,
          //   srcActive: trackActive,
          //   checked: false,
          //   id: 6
          // }
        ],
        extension_options: [{
          name: '1万元以下',
          describe: '尝鲜体验',
          checked: false,
          id: 0,
          budget: 50000,
          budget_min: 0
        }, {
          name: '1 ~ 5万元',
          describe: '基础预算',
          checked: false,
          id: 1,
          budget: 50000,
          budget_min: 10000
        }, {
          name: '5 ~ 10万元',
          describe: '较多预算',
          checked: false,
          id: 2,
          budget: 100000,
          budget_min: 50000
        }, {
          name: '请输入预算',
          describe: '自定义预算',
          checked: false,
          id: 3,
          toInput: false,
          budget: 0,
          budget_min: 0
        }],
        Genders: [{
            name: '不限',
            checked: true,
            id: 0
          },
          {
            name: '男性为主',
            checked: false,
            id: 1
          },
          {
            name: '女性为主',
            checked: false,
            id: 2
          }
        ],
        ages: [{
            name: '不限',
            value: "",
            checked: true
          },
          {
            name: '18~25',
            value: '18-25',
            checked: false
          },
          {
            name: '26~32',
            value: '26-32',
            checked: false
          },
          {
            name: '33~39',
            value: '33-39',
            checked: false
          },
          {
            name: '40~46',
            value: '40-46',
            checked: false
          },
          {
            name: '>46',
            value: '>46',
            checked: false
          },
          {
            name: '其他年龄',
            value: '<18',
            checked: false
          }
        ],
        areas: [],
        styles: [{
          name: '科技数码',
          checked: false,
          id: 64
        }, {
          name: '测评',
          checked: false,
          id: 15
        }, {
          name: '剧情搞笑',
          checked: false,
          id: 97
        }, {
          name: '颜值达人',
          checked: false,
          id: 72
        }, {
          name: '游戏',
          checked: false,
          id: 200
        }, {
          name: '艺术文化',
          checked: false,
          id: 87
        }, {
          name: '生活',
          checked: false,
          id: 36
        }, {
          name: '二次元',
          checked: false,
          id: 216
        }, {
          name: '运动健身',
          checked: false,
          id: 60
        }, {
          name: '音乐',
          checked: false,
          id: 201
        }],
        priceSelect: -1,

        keyWords: [{
            name: '粉丝更多',
            checked: false,
            id: 'convert_effective'
          },
          {
            name: '性价比更高',
            checked: false,
            id: 'vv'
          },
          {
            name: '播放量最高',
            checked: false,
            id: 'cost_effective'
          },
          {
            name: '带货能力更强',
            checked: false,
            id: 'follower'
          }
        ],
        query: {},
        tableData: [],
        describe: '',
        showNoData: false
      }
    },
    watch: {
      price(val, oldval) {
        if (val === '') {
          return
        }
        if (!(/^(0|[1-9][0-9]*)$/.test(val))) {
          this.price = oldval
          return;
        }
        if (parseInt(val) > 10000) {
          this.price = '10000'
          this.extension_options[3].describe = '最大金额不超过1亿元'
          this.textActive = true
        }
        if (parseInt(val) < 10000) {
          this.extension_options[3].describe = '自定义预算'
          this.textActive = false
        }
      }
    },
    computed: {
      allChecked: function () {
        let checkUp = true
        this.areas.map(t => {
          if (t.checked === false) {
            checkUp = false
          }
        })
        return checkUp
      },
      selectedAreas: function () {
        let seledAreas = []
        this.areas.map(t => {
          if (t.checked === true) {
            seledAreas.push(t.name)
          }
        })
        return seledAreas
      },
      allStyle: function () {
        let checkUp = true
        this.styles.map(t => {
          if (t.checked === true) {
            checkUp = false
          }
        })
        return checkUp
      }
    },
    created() {

      this.getData()
    },
    methods: {
      getData() {
        this.$axios.all([this.$api.getData.getQueryInfo(), this.$api.helper.getIndustry()]).then(([area, industry]) => {
          // console.log(area, industry)
          this.areas = Object.keys(area.data.data.location).map(t => {
            return {
              name: t,
              checked: false
            }
          })
          this.industrys = industry.data.data.map(t => {
            return {
              label: t.category_name,
              value: t.category_id,
              children: t.children ? t.children.map(x => {
                return {
                  label: x.category_name,
                  value: x.category_id,
                }
              }) : []
            }
          })
        })
      },
      setTarget(val) {
        this.target_options = this.target_options.map(t => {
          t.checked = false
          return t
        })
        val.checked = true
      },
      setPrice(val) {
        this.extension_options = this.extension_options.map(t => {
          t.checked = false
          return t
        })
        val.checked = true
        this.priceSelect = val.id
        if ('toInput' in val) {
          val.toInput = true
          this.$nextTick(function () {
            this.$refs.toInput[0].focus()
          })
        }
      },
      setPriceName(val) {
        val.toInput = false
        val.name = this.price + '万元'
        this.extension_options[3].describe = '自定义预算'
        this.textActive = false
        this.extension_options[3].budget = parseFloat(this.price) * 10000
      },
      setGender(val) {
        this.Genders = this.Genders.map(t => {
          t.checked = false
          return t
        })
        val.checked = true
      },
      setAges(val) {
        this.ages = this.ages.map(t => {
          t.checked = false
          return t
        })
        val.checked = true
      },
      setAreaBtn(val) {
        if (val === 'all') {
          if (this.allChecked) {
            this.areas = this.areas.map(t => {
              t.checked = false
              return t
            })
          } else {
            this.areas = this.areas.map(t => {
              t.checked = true
              return t
            })
          }
        } else {
          val.checked = !val.checked
        }
      },
      setSelectedAreas(val) {
        if (val === 'all') {
          this.areas.map(t => {
            t.checked = false
            return t
          })
        } else {
          this.areas.map(t => {
            if (t.name === val) {
              t.checked = false
            }
            return t
          })
        }
      },
      setStyle(val) {
        if (val === 'all') {
          this.styles = this.styles.map(t => {
            t.checked = false
            return t
          })
        } else {
          val.checked = !val.checked
        }
      },
      matching() {
        LA.track('dy_talent_rec');
        if (this.industry.length === 0) {
          this.$message({
            message: '请选择行业！',
            type: 'error'
          });
          return
        }
        // if (!priceQuery) {
        //   this.$message({
        //     message: '请输入正确的预算！',
        //     type: 'error'
        //   });
        //   return
        // }
        let query = {}
        const areasQuery = this.areas.filter(t => t.checked === true).map(t => {
          return t.name
        })
        const priceQuery = this.extension_options.filter(t => t.id === this.priceSelect).map(t => {
          return {
            budget: t.budget,
            budget_min: t.budget_min === 0 ? '' : t.budget_min
          }
        })
        if (priceQuery.length === 0 || !priceQuery[0].budget) {
          this.$message({
            message: '请输入正确的预算！',
            type: 'error'
          });
          return
        }
        const interest = this.styles.filter(t => t.checked === true).map(t => {
          return t.id
        })
        const interestNa = this.styles.filter(t => t.checked === true).map(t => {
          return t.name
        })
        const agesNmae = this.ages.filter(t => t.checked === true)[0].name
        query = {
          ...query,
          ...{
            product_name: this.productName,
            first_class_category: this.industry[1],
            fans_province: areasQuery.length === 0 ? '' : areasQuery.join(','),
            interest_labels: interest.length === 0 ? '' : interest.join(','),
            promotion_target: this.target_options.filter(t => t.checked === true)[0].id,
            fans_gender: this.Genders.filter(t => t.checked === true)[0].id,
            fans_age: this.ages.filter(t => t.checked === true)[0].value,
          },
          ...priceQuery[0]
        }
        const industryName = this.industrys.filter(t => t.value === this.industry[0])
        industryName[0].children = industryName[0].children.filter(t => t.value === this.industry[1])
        const targetName = this.target_options.filter(t => t.checked === true)[0].name
        const priceName = this.extension_options.filter(t => t.id === this.priceSelect)[0].name
        const grenderName = this.Genders.filter(t => t.checked === true)[0].name
        const areaName = areasQuery.length === 0 ? '' : areasQuery.join('、')
        const interestName = interestNa.length === 0 ? '' : interestNa.join('、')
        const decr = industryName[0].label + '/' + industryName[0].children[0].label + (this.productName ? ("," + this
          .productName) : '') + ',' + targetName + ', 预算' + priceName + ((agesNmae === '不限') ? '' : ((agesNmae ===
          '其他年龄') ? (',' + agesNmae) : (',' + agesNmae + '岁'))) + (grenderName === '不限' ?
          '' : (',' + grenderName)) + (
          areaName ? (',' + areaName) : "") + (interestName ? (',' + interestName) : '');
        console.log(decr)
        this.describe = decr
        this.query = query
        this.listShow = true
        // this.$router.push({
        //   path: '/byHelpLIst',
        //   query: {
        //     query,
        //     decr
        //   }
        // })
        this.getTableData()
      },

      setKeyword(val) {
        this.keyWords = this.keyWords.map(t => {
          t.checked = false
          return t
        })
        val.checked = true
        this.showNoData = true
        this.getTableData()
      },
      getTableData() {
        const keyword1 = this.keyWords.filter(t => t.checked)
        this.query = {
          ...this.query,
          ...{
            prefer_info: keyword1.length === 0 ? '' : keyword1[0].id
          }
        }
        this.$api.helper.getData(this.query).then(res => {
          console.log(res)
          if (res.data.code === 0) {
            this.tableData = res.data.data
            this.showNoData = false
          } else {
            this.$message.error(res.data.error);
          }
        })
      },
      getPriceDetail(val) {
        if (!val.prices) {
          this.$api.getData.getDarenPrice('/' + val.author_id).then(res => {
            console.log(res)
            this.tableData = this.tableData.map(t => {
              if (t.author_id === val.author_id) {
                t = {
                  ...t,
                  ...{
                    prices: res.data.data.price_info
                  }
                }
              }
              return t
            })
          })
        }
      },
      changeData() {
        this.showNoData = true
        this.getTableData()
      },
      tableBtnClick(val) {
        // console.log(val)
        let routeData = this.$router.resolve({
          path: '/daren',
          query: {
            id: val.author_id
          }
        })
        window.open(routeData.href, "_blank");
      },
      backSet() {
        this.listShow = false
        this.tableData = []
        // this.$router.push('/helper')
      }
    }
  }
</script>

<style scoped>
  h1,
  h2,
  h3,
  h4,
  h5,
  p {
    margin: 0;
    padding: 0;
  }

  .content {
    width: 1200px;
    margin: 0 auto;

  }

  .content .head {
    display: flex;
    flex-direction: column;
    background: url(../../assets/help/header_bg.png);
    width: 100%;
    height: 148px;
    border-radius: 6px;
    padding: 45px 40px;
    box-sizing: border-box;
    justify-content: space-between;
  }

  .content .head h2 {
    font-size: 20px;
    font-weight: 500;
    color: #FFFFFF;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }

  .content .head p {
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    opacity: 0.72;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  }

  .content .condition {
    width: 100%;
    margin-top: 20px;
    background: #fff;
    box-sizing: border-box;
    padding: 30px 30px;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
    border-bottom: 1px solid #F5F5F6;
  }

  .content .condition h3 {
    font-size: 16px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: bold;
    color: #333333;
    position: relative;
    width: max-content;
  }

  .content .condition h3::after {
    font-size: 16px;
    content: '*';
    position: absolute;
    top: 0;
    right: -10px;
    color: #FF6F28;
  }

  .content .el_sel>>>.el-input__inner {
    width: 175px;
    height: 34px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 2px;
  }

  .condition .option_box+.option_box {
    margin-top: 30px;
  }


  .input_boxs {
    display: flex;
    margin-top: 20px;
    align-items: center;
  }

  .input_boxs .input_box {
    display: flex;
    flex-direction: column;
  }

  .input_boxs .input_box+.input_box {
    margin-left: 24px;
  }

  .option_box .box_title {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #999999;
    margin-bottom: 12px;
  }

  .input_boxs .input_box .el_input>>>.el-input__inner {
    width: 360px;
    height: 34px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 2px;
  }

  .check_boxs {
    display: flex;
    flex-wrap: wrap;
  }

  .check_boxs .check_box {
    width: 340px;
    height: 84px;
    background: #FFFFFF;
    border: 1px solid #D0D3D9;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 21px 24px;
    display: flex;
    align-content: center;
    justify-content: space-between;
    position: relative;
    cursor: pointer;
    margin-top: 24px;
    margin-right: 20px;
  }

  .check_boxs .check_box:nth-child(3n) {
    margin-right: 0px;
  }

  .check_boxs .check_box.active {
    border: 1px solid #FF5C00;
  }

  .check_boxs .check_box.active::before,
  .extension .sel_price .option_price.active::before {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    background: url(../../assets/help/checked_1.png) no-repeat;
    width: 26px;
    height: 26px;
  }

  .check_boxs .check_box .check_img {
    width: 42px;
    height: 42px;
    background: #FFFFFF;
    border: 1px solid #D0D3D9;
    border-radius: 50%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .check_boxs .check_box.active .check_img {
    border: 1px solid #FF6F28;
  }

  .check_boxs .check_box .check_info {
    width: 235px;
    height: 42px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
  }

  .check_boxs .check_box .check_info h4 {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #333333;
  }

  .check_boxs .check_box.active .check_info h4 {
    color: #FF5C00;
  }

  .check_boxs .check_box .check_info p {
    font-size: 12px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #999999;
  }

  .extension {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }

  .extension .sel_price {
    display: flex;
  }

  .extension .sel_price .option_price {
    width: 180px;
    height: 84px;
    border: 1px solid #D0D3D9;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
    position: relative;
  }

  .extension .sel_price .option_price .price_input {
    display: flex;
    width: 137px;
    border-bottom: 1px solid #E0E0E0;
    color: #FF5C00;
  }

  .extension .sel_price .option_price .price_input input {
    border: none;
    width: 100px;
    color: #FF5C00;
  }

  .extension .sel_price .option_price .price_input input:focus-visible {
    outline: none;
  }

  .extension .sel_price .option_price.active {
    border: 1px solid #FF5C00;
  }

  .extension .sel_price .option_price.active h4 {
    color: #FF5C00;
  }

  .extension .sel_price .price_out+.price_out {
    margin-left: 20px;
  }

  .extension .sel_price .option_price h4 {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #333333;
  }

  .extension .sel_price .option_price p {
    font-size: 12px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #999999;
  }

  .extension .sel_price .option_price p.active {
    color: #FF5C00;
  }

  .option_box .portrait {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }

  .option_box .portrait .portrait_box {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
  }

  .option_box .portrait .portrait_box .Gender_box {
    display: flex;
  }

  .option_box .portrait .portrait_box .Gender_box .Gender {
    width: 100px;
    height: 34px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    text-align: center;
    line-height: 34px;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #333333;
    position: relative;
    margin-left: -1px;
    z-index: 0;
    cursor: pointer;
  }

  .option_box .portrait .portrait_box .Gender_box .Gender.active {
    background: #FFF2EB;
    border: 1px solid #FF5C00;
    z-index: 1;
  }

  .option_box .portrait .portrait_box .Gender_box .Gender:nth-child(1) {
    margin-left: 0;
    border-radius: 2px 0px 0px 2px;
  }

  .option_box .portrait .portrait_box .Gender_box .Gender:nth-last-child(1) {
    border-radius: 0px 2px 2px 0px;
  }

  .option_box .portrait .portrait_box .Gender_box .age {
    width: 100px;
    height: 34px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    text-align: center;
    line-height: 34px;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #333333;
    position: relative;
    margin-left: -1px;
    z-index: 0;
    cursor: pointer;
  }

  .option_box .portrait .portrait_box .Gender_box .age.active {
    background: #FFF2EB;
    border: 1px solid #FF5C00;
    z-index: 1;
  }

  .option_box .portrait .portrait_box .Gender_box .age::after {
    content: '';
    width: 0px;
    height: 0px;
    border-right: 3px solid #E0E0E0;
    border-left: 3px solid transparent;
    border-top: 3px solid #E0E0E0;
    border-bottom: 3px solid transparent;
    top: 0;
    right: 0;
    position: absolute;
  }

  .option_box .portrait .portrait_box .Gender_box .age.active::after {
    border-right: 3px solid #FF5C00;
    border-left: 3px solid transparent;
    border-top: 3px solid #FF5C00;
    border-bottom: 3px solid transparent;
  }

  .option_box .portrait .select_area {
    display: flex;
    margin-top: 10px;
  }

  .option_box .portrait .select_area .box {
    width: 200px;
    height: 239px;
    border-radius: 2px;
    margin-right: 16px;
    border: 1px solid #E0E0E0;
    box-sizing: border-box;
  }

  .option_box .portrait .select_area .box .title {
    width: 200px;
    height: 39px;
    background: #F0F0F0;
    border: 1px solid #E0E0E0;
    border-radius: 2px;
    box-sizing: border-box;
    padding: 10px 12px;
    display: flex;
    box-sizing: border-box;
    margin: -1px 0 0 -1px;
  }

  .option_box .portrait .select_area .box .title h5 {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #333333;
  }

  .option_box .portrait .select_area .box .title div {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #38A1FF;
    margin-left: auto;
    cursor: pointer;
  }

  .option_box .portrait .select_area .box .area_option {
    width: 100%;
    height: 200px;
    overflow: scroll;
    padding-top: 8px;
    box-sizing: border-box;
  }

  .option_box .portrait .select_area .box .area_option .area {
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #333333;
    height: 30px;
    padding-left: 12px;
    box-sizing: border-box;
  }

  .option_box .portrait .select_area .box .area_option .area:hover {
    cursor: pointer;
    background: #F5F5F5;
  }

  .option_box .portrait .select_area .box .area_option .area i {
    display: inline-block;
    width: 16px;
    height: 16px;
    background: #FFFFFF;
    border: 1px solid #E9E9E9;
    border-radius: 2px;
    margin-right: 8px;
    box-sizing: border-box;
  }

  .option_box .portrait .select_area .box .area_option .area.active i {
    background-color: #FF6F28;
    border: 1px solid #FF6F28;
    position: relative;

  }

  .option_box .portrait .select_area .box .area_option .area.active i::before {
    content: '';
    background: url(../../assets/help/checked.png) no-repeat;
    width: 10px;
    height: 9px;
    position: absolute;
    top: 2px;
    left: 2px;
    z-index: 2;
  }

  .option_box .portrait .select_area .box .Selected {
    width: 100%;
    height: 200px;
    overflow: scroll;
    padding: 12px;
    box-sizing: border-box;
    position: relative;
  }

  .option_box .portrait .select_area .box .Selected .Selected_item {
    width: 158px;
    height: 26px;
    background: #F5F5F5;
    border-radius: 2px;
    position: relative;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #333333;
    line-height: 26px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    cursor: pointer;
  }

  .option_box .portrait .select_area .box .Selected .Selected_item+.Selected_item {
    margin-top: 10px;
  }

  .option_box .portrait .select_area .box .Selected .Selected_item i {
    background: url(../../assets/help/cancel.png);
    display: flex;
    width: 8px;
    height: 8px;
    margin-left: auto;
  }

  .option_box .portrait .select_area .box .Selected .nothing {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .option_box .portrait .select_area .box .Selected .nothing i {
    background: url(../../assets/help/nothing_1.png);
    width: 39px;
    height: 35px;
    margin-bottom: 10px;
  }

  .option_box .portrait .select_area .box .Selected .nothing p {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #999999;
  }

  .option_box .like_style {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
  }

  .option_box .like_style>div {
    width: 100px;
    height: 34px;
    text-align: center;
    line-height: 34px;
    margin-right: 10px;
    box-sizing: border-box;
    border-radius: 2px;
    background: #F9F9F9;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #333333;
  }

  .option_box .like_style>div.active {
    background: #FFF2EB;
    border: 1px solid #FF5C00;
    line-height: 32px;
    color: #FF5C00;
  }

  .option_box .like_style .style_checked {
    position: relative;
  }

  .option_box .like_style .style_checked::after {
    content: '';
    background: url(../../assets/help/nochecked.png);
    width: 19px;
    height: 19px;
    position: absolute;
    top: 0;
    right: 0;
  }

  .option_box .like_style .style_checked.active::after {
    content: '';
    background: url(../../assets/help/checked_2.png);
    width: 17px;
    height: 17px;
    position: absolute;
    top: 0;
    right: 0;
  }

  .btn_box {
    padding: 30px 0;
    box-sizing: border-box;
    background: #fff;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    display: flex;
    justify-content: center;
  }

  .btn_box .btn {
    width: 160px;
    height: 46px;
    background: #FF6F28;
    border-radius: 2px;
    font-size: 15px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 46px;
    text-align: center;
  }

  .btn_box .btn:hover {
    background: #FF5E0E;
    cursor: pointer;
  }





  .content .list {
    margin-top: 20px;
    width: 100%;
    background: #FFFFFF;
    border-radius: 6px;
  }

  .content .list .matchingInfo {
    width: 100%;
    height: 52px;
    background: #FAFAFA;
    border-radius: 6px 6px 0px 0px;
    display: flex;
    box-sizing: border-box;
    padding: 0 26px;
    align-items: center;
  }

  .content .list .matchingInfo .title {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #A3A3A3;
    margin-right: 15px;
  }

  .content .list .matchingInfo .info {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 980px;
  }

  .content .list .matchingInfo .btn {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #FF6F28;
    margin-left: auto;
    cursor: pointer;
  }

  .content .list .rec {
    display: flex;
    box-sizing: border-box;
    padding: 0 26px;
    margin-top: 30px;
  }

  .content .list .rec h5 {
    font-size: 16px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #333333;
    margin-right: 30px;
  }

  .content .list .rec .btn {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #38A1FF;
    cursor: pointer;
  }

  .content .list .rec .btn i {
    transform: rotate(90deg);
  }

  .content .list .keywords {
    display: flex;
    align-items: center;
    margin-top: 20px;
    box-sizing: border-box;
    padding: 0 26px;
  }

  .content .list .keywords p {
    margin-right: 20px;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #666666;
  }

  .content .list .keywords .keyword {
    width: 90px;
    height: 29px;
    background: #FAFAFA;
    border-radius: 2px;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #666666;
    line-height: 29px;
    text-align: center;
    cursor: pointer;
  }

  .content .list .keywords .keyword+.keyword {
    margin-left: 16px;
  }

  .content .list .keywords .keyword.active {
    box-sizing: border-box;
    line-height: 27px;
    border: 1px solid #FF5C00;
    background: #FFF2EB;
    color: #FF6F28;
  }

  .content .list .datas {
    box-sizing: border-box;
    padding: 0 26px;
  }

  .content .list .datas .item {
    display: flex;
    align-items: center;
    height: 154px;
    width: 100%;
    border-bottom: 1px solid #F0F0F0;
  }

  .content .list .datas .item:nth-last-child(1) {
    border-bottom: none;
  }

  .content .list .datas .item img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-bottom: auto;
    margin-top: 40px;
    border: 1px solid #e0e0e0;
  }

  .content .list .datas .item .info {
    margin-left: 20px;
    width: 430px;
  }

  .content .list .datas .item .info h2 {
    font-size: 16px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #333333;
  }

  .content .list .datas .item .info .cate {
    display: inline-block;
    height: 26px;
    background: #F6F6F6;
    border-radius: 2px;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    color: #333333;
    line-height: 26px;
    text-align: center;
    padding: 0 10px;
    margin: 12px 0;
  }

  .content .list .datas .item .info .tags {
    display: flex;
  }

  .content .list .datas .item .info .tags .tag {
    height: 24px;
    background: #FFF2EB;
    border-radius: 2px;
    font-size: 12px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #FF6F28;
    line-height: 24px;
    padding: 0 10px;
  }

  .content .list .datas .item .info .tags .tag+.tag {
    margin-left: 8px;
  }

  .content .list .datas .item .num {
    width: 100px;
  }

  .content .list .datas .item .num div {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 800;
    color: #666666;
    text-align: center;
  }

  .content .list .datas .item .num p {
    margin-top: 6px;
    font-size: 12px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #999999;
    text-align: center;
  }

  .content .list .datas .item .line {
    width: 1px;
    height: 30px;
    background: #F5F5F6;
    margin: 0 70px;
  }

  .content .list .datas .item .price {
    color: #FF5C00;
    display: flex;
  }

  .content .list .datas .item .price span {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 800;
    margin-top: 9px;
  }

  .content .list .datas .item .price .price_text {
    font-size: 20px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 800;
    color: #FF5C00;
    margin-right: 6px;
  }

  .content .list .datas .item .price .preview:hover {
    cursor: pointer;
  }

  .content .list .datas .item .price .preview i {
    display: block;
    background: url(../../assets/help/preview.png);
    width: 14px;
    height: 14px;
  }

  .content .list .datas .item .btn {
    width: 72px;
    height: 30px;
    background: #FF6F28;
    border-radius: 2px;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #FFFFFF;
    margin-left: auto;
  }

  .in_preview {
    padding: 24px;
    box-sizing: border-box;
  }

  .in_preview h3 {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #999999;
    height: 30px;
    border-bottom: 1px solid #F5F5F6;
  }

  .in_preview .price_item {
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .in_preview .price_item .corr_price {
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    color: #FF5C00;
    font-weight: 800;
    display: flex;
  }

  .in_preview .price_item .corr_price span {
    font-size: 14px;
    padding-top: 4px;
  }

  .in_preview .price_item .corr_price .price_t {
    font-size: 18px;
  }

  .noData {
    width: 100%;
    height: 450px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .noData p {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #666666;
    line-height: 32px;
  }

  .datas_noData {
    width: 100%;
    height: 450px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .datas_noData p {
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    color: #666666;
    line-height: 32px;
  }
</style>